import { Button } from "@mui/material";
import React from "react";
import toast from "react-hot-toast";
import { useChangeCarStatusMutation } from "state/api";

const WarningModal = ({ data, handleCloseModal, status }) => {
  const [changeCarStatus] = useChangeCarStatusMutation();

  const handleStatusChange = () => {
    changeCarStatus({
      id: data._id,
      status: status,
    })
      .unwrap()
      .then((res) => {
        toast.success("Status Changed Successfully");
      })
      .catch((err) => {
        toast.error(err.data.message);
      });

    handleCloseModal();
  };
  return (
    <div className="fixed inset-0 bg-black bg-opacity-25 backdrop-blur-sm flex items-center justify-center">
      <div className="bg-white p-4 rounded w-[350px]">
        <h2 className="font-semibold text-center text-xl text-gray-700">
          Are you sure, you want to change status to {status} ?
        </h2>

        <div className="text-center flex items-center justify-center gap-2">
          <Button
            onClick={handleStatusChange}
            className=" text-white  bg-blue-500 border-0 px-6 py-2 focus:outline-none hover:bg-blue-600 rounded cursor-pointer"
          >
            Change
          </Button>
          <Button
            className=" text-white  bg-teal-500 border-0 px-6 py-2 focus:outline-none hover:bg-teal-600 rounded cursor-pointer"
            onClick={handleCloseModal}
          >
            Close
          </Button>
        </div>
      </div>
    </div>
  );
};

export default WarningModal;
